import script from "./StarBti.vue?vue&type=script&setup=true&lang=js"
export * from "./StarBti.vue?vue&type=script&setup=true&lang=js"

import "./StarBti.vue?vue&type=style&index=0&id=7b8acf70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8acf70"]])

export default __exports__